import showdown from 'showdown';

const markdownToHtml = (markdown) => {
  const options = { simpleLineBreaks: true, tasklists: true }
  const converter = new showdown.Converter(options);
  return converter.makeHtml(markdown);
}
export default markdownToHtml;